var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdyenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 30,
    viewBox: "0 0 90 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0ABF53",
    fillRule: "evenodd",
    d: "M12.68 6.98H.23v4.04h8.11c.5 0 .91.42.91.93v7.17H7.52a.92.92 0 0 1-.91-.93v-5.14H3.18A3.21 3.21 0 0 0 0 16.3v3.62c0 1.8 1.42 3.25 3.18 3.25h12.68V10.22a3.2 3.2 0 0 0-3.18-3.24m15.08 12.14h-1.73a.92.92 0 0 1-.91-.93V6.98h-3.43a3.21 3.21 0 0 0-3.18 3.24v9.7c0 1.8 1.42 3.25 3.18 3.25h12.68V.23h-6.6v18.89Zm18.51 0h-1.74c-.5 0-.9-.42-.9-.93V6.98H37v12.94c0 1.8 1.43 3.25 3.19 3.25h6.07v2.02h-9.03v4.72H49.7a3.21 3.21 0 0 0 3.18-3.25V6.98h-6.61v12.14ZM68.2 6.98H55.52v12.94c0 1.8 1.43 3.25 3.18 3.25h12.46v-4.05h-8.12c-.5 0-.9-.42-.9-.93v-7.17h1.73c.5 0 .9.42.9.93v5.14h3.43a3.21 3.21 0 0 0 3.18-3.24v-3.63a3.2 3.2 0 0 0-3.18-3.24m18.51 0H74.03v16.19h6.6V11.02h1.74c.5 0 .91.42.91.93v11.22h6.61V10.22a3.2 3.2 0 0 0-3.18-3.24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdyenLogo);
export default __webpack_public_path__ + "static/media/adyen-logo.0b9515335460131c423e93a10854b344.svg";
export { ForwardRef as ReactComponent };